import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import { useIsMobile } from '../../../services/responsiveUtils';
import 'react-quill/dist/quill.snow.css';
import './TextEditor.styles.css';

const modules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'strike', 'code-block']
    ]
  },
  clipboard: {
    matchVisual: true
  }
};

const mobileModules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline']
    ]
  },
  clipboard: {
    matchVisual: true
  }
};

interface TextEditorProps {
  labelText: string;
  setValue: (value: string) => void;
  value: string;
  disabled: boolean;
}

const TextEditor: React.FC<TextEditorProps> = ({ labelText, setValue, value, disabled }) => {
  const quillRef = useRef<ReactQuill | null>(null);
  const isMobile = useIsMobile();

  const handleChange = (content: string) => {
  setValue(content);
  };

  return (
    <div className="wrapper notranslate" translate="no">
      <label className="label">{labelText}</label>
      <ReactQuill
        className="editor"
        theme='snow'
        value={value}
        onChange={handleChange}
        modules={isMobile ? mobileModules : modules}
        ref={quillRef}
        readOnly={disabled}
      />
    </div>
  );
};

export default TextEditor;